export const defaultPreChatSurveyPaneACContainerStyles = {
  border: "1px solid #ECECEC",
  borderRadius: "4px",
  margin: "3%"
};